import { STORAGE_KEY_ENUM } from 'enums';
import { LocalStorage, Token } from 'utils';
import { FormattedMessage } from 'react-intl';

class Authentication {
  private token: string | null;

  constructor() {
    this.token = this.getToken();

    if (this.token && Token.isExpired(this.token)) {
      window.dispatchEvent(
        new CustomEvent('errorEvent', {
          detail: <FormattedMessage id="login.sessionExpire" defaultMessage="Oturum Süresi Dolmuştur" />,
        })
      );

      this.clearCache();
    }
  }

  getToken() {
    return LocalStorage.getItem(STORAGE_KEY_ENUM.TOKEN);
  }

  setToken(token: string) {
    LocalStorage.setItem(STORAGE_KEY_ENUM.TOKEN, token);
  }

  hasSession() {
    return Boolean(this.getToken());
  }

  getLoggedUser(): string {
    return LocalStorage.getItem(STORAGE_KEY_ENUM.LOGGED_USER) || '';
  }

  setLoggedUser(userInfo: string) {
    LocalStorage.setItem(STORAGE_KEY_ENUM.LOGGED_USER, userInfo);
  }

  logOut() {
    this.clearCache();

    setTimeout(() => {
      window.location.href = '/';
    }, 100);
  }

  clearCache() {
    LocalStorage.removeItem(STORAGE_KEY_ENUM.TOKEN);
    LocalStorage.removeItem(STORAGE_KEY_ENUM.LOGGED_USER);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Authentication();
